/* global axios */
// API da seção IA (ver AI.md).
import ApiClient from './ApiClient';

class AiAPI extends ApiClient {
  constructor() {
    super('ai', { accountScoped: true });
  }

  getDocuments() {
    return axios.get(`${this.url}/documents`);
  }

  uploadDocument(file, title = '') {
    const formData = new FormData();
    formData.append('file', file);
    if (title) formData.append('title', title);
    return axios.post(`${this.url}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  reprocessDocument(id) {
    return axios.post(`${this.url}/documents/${id}/reprocess`);
  }

  deleteDocument(id) {
    return axios.delete(`${this.url}/documents/${id}`);
  }

  getInboxSettings() {
    return axios.get(`${this.url}/inbox_settings`);
  }

  updateInboxSetting(inboxId, data) {
    return axios.patch(`${this.url}/inbox_settings/${inboxId}`, data);
  }

  // schedulingState: andamento do agendamento devolvido na resposta anterior (Sandbox não grava nada).
  runSandbox(inboxId, messages, schedulingState = {}) {
    return axios.post(`${this.url}/sandbox`, {
      inbox_id: inboxId,
      messages,
      scheduling_state: schedulingState,
    });
  }
}

export default new AiAPI();
